module.exports = __webpack_public_path__ + "static/media/agentInfoMobile.8f4ce726.png";